/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PosTabType {
  User = 'USER',
  Visitor = 'VISITOR',
  Anon = 'ANON'
}
